/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

// Elements
import TitleDefault from 'components/elements/TitleDefault'
import HeroImage from 'components/elements/HeroImage'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import ParseContent from 'components/shared/ParseContent'
import GravityForm from 'components/shared/GravityForm'

const AddressBox = styled.div`
  position: relative;
`
const InfoBox = styled.div`
  position: relative;
`
const FormBox = styled.div`
  position: relative;
  background-color: ${props => props.theme.color.face.grey};
`

const PageTemplate = ({
  data: {
    page: { title, path, yoast_meta: yoast, acf },
  },
}) => {
  return (
    <Layout>
      <SEO yoast={yoast} path={path} article />

      <HeroImage fields={acf.banner} />
      <section className="contact-row">
        <div className="container py-lg-5">
          <div className="row py-5 align-items-center">
            <div className="col-lg-4">
              <AddressBox className="d-flex flex-column align-items-center mb-5">
                <img src={acf.address.icon.localFile.publicURL} width="41" alt="" className="mb-4" />
                <TitleDefault className="text-center mb-3">{acf.address.title}</TitleDefault>
                <p className="text-center mb-0">
                  <span>Chr. Ger. Rehobothkerk</span>
                </p>
                <p className="text-center mb-0">
                  <span>
                    {acf.address.streetname}
                    {' '}
                    {acf.address.housnumber}
                    ,
                  </span>
                </p>
                <p className="text-center">
                  <span>
                    {acf.address.zipcode}
                    {' '}
                    {acf.address.city}
                  </span>
                </p>
              </AddressBox>
              <InfoBox className="d-flex flex-column align-items-center">
                <img src={acf.contact.icon.localFile.publicURL} width="41" alt="" className="mb-4" />
                <TitleDefault className="text-center mb-3">{acf.contact.title}</TitleDefault>
                <ParseContent content={acf.contact.description} />
              </InfoBox>
            </div>
            <FormBox className="col-lg-8 p-5">
              <GravityForm id={1} />
            </FormBox>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path

      acf {
        banner {
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }
        address {
          title
          icon {
            localFile {
              publicURL
            }
          }
          streetname
          housnumber
          zipcode
          city
        }
        contact {
          title
          icon {
            localFile {
              publicURL
            }
          }
          description
        }
      }

      yoast_meta {
        name
        content
        property
      }
    }
  }
`

export default PageTemplate
